import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import useRecruiter from "contexts/User/useRecruiter";
import {AwaitableModal} from "hooks/useAwaitableModal";
import {useNavigate} from "react-router";

const Subscribe: AwaitableModal<{}, {}> = ({open, resolve}) => {
  const recruiter = useRecruiter();
  const navigate = useNavigate();

  const upgrade = !!recruiter.subscription?.plan;

  const onSubscribe = () => navigate("/subscription");

  return (
    <Modal open={open} close={resolve}>
      <ModalLayout
        title={upgrade ? "Upgrade Subscription" : "Subscription Required"}
        footer={
          <button onClick={onSubscribe} className="btn-primary ml-auto">
            {upgrade ? "Upgrade Now" : "See Plans"}
          </button>
        }
      >
        <p className="text-sm text-brand-muted">
          {upgrade
            ? "Learn about the benefits of our different plans."
            : "Check out our plans to see which one fits you best."}
        </p>
      </ModalLayout>
    </Modal>
  );
};

export default Subscribe;
